import apiWithAuth from './apiWithAuth';

const privacyPolicyApi = {

  // Get the latest privacy policy
  getPrivacyPolicy: async () => {
    try {
      const response = await apiWithAuth.get('/website-main/privacy-policy/public');
      return { success: true, data: response.data };
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: true, data: null }; // No policy exists yet
      }
      return { success: false, error: error.response?.data?.error || 'Failed to load privacy policy' };
    }
  },

  // Create or update privacy policy
  savePrivacyPolicy: async (payload) => {
    try {
      const response = await apiWithAuth.put('/website-main/privacy-policy/privacy-policy', payload);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Failed to save privacy policy' };
    }
  },

  // Delete privacy policy
  deletePrivacyPolicy: async () => {
    try {
      await apiWithAuth.delete('/website-main/privacy-policy/privacy-policy');
      return { success: true };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Failed to delete privacy policy' };
    }
  },
};


export default privacyPolicyApi;
